import { useEffect, useMemo, useState } from "react"
import CustomTable from '../../components-legacy/CustomTable.jsx'
import { server } from "../chat/Server.js"

export default function StrategyResultsDeals({ strId, backtest }) {
    const [data, setData] = useState(null)
    const [error, setError] = useState(null)

    useEffect(() => {
        if (backtest.processingStatus !== 'completed') {
            setData(null)
            return
        }
        server.api('strategy/backtest/results', { strId, backtestId: backtest.backtestId, section: 'deals' }).then(res => {
            setData(JSON.parse(res))
        }).catch(() => {
            setError('Error retrieving backtest deals')

        })
    }, [strId, backtest])

    const dealsTableColumns = useMemo(() => [
        {
            accessorKey: "Deal",
            header: () => "Id",
            cell: info => info.getValue(),
            enableSorting: true,
            sortingFn: 'alphanumeric',
        },
        {
            accessorKey: "Time",
            header: () => "Time",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Symbol",
            header: () => "Symbol",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Type",
            header: () => "Type",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Direction",
            header: () => "Direction",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Volume",
            header: () => "Volume",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Price",
            header: () => "Price",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Order",
            header: () => "Order",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Commission",
            header: () => "Commission",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Swap",
            header: () => "Swap",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Profit",
            header: () => "Profit",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Balance",
            header: () => "Balance",
            cell: info => info.getValue()
        },
        {
            accessorKey: "Comment",
            header: () => "Comment",
            cell: info => info.getValue()
        },
    ], [])

    const dealsTableData = data ? data.map((item) => {
        return {
            Deal: item.Deal,
            Time: item.Time,
            Symbol: item.Symbol,
            Type: item.Type,
            Direction: item.Direction,
            Volume: item.Volume,
            Price: item.Price,
            Order: item.Order,
            Commission: item.Commission,
            Swap: item.Swap,
            Profit: item.Profit,
            Balance: item.Balance,
            Comment: item.Comment
        }


    }) : []

    if (backtest.processingStatus === 'error') {
        return null
    }

    if (backtest.processingStatus === 'processing') {
        return <div className="text-body text-muted-foreground">In Progress...</div>
    }

    if (error) {
        return (
            <section className="p-6 rounded-md min-w-[320px] border border-border bg-card text-foreground">
                <div className="msgError py-2 px-4 rounded-md border border-danger-dim bg-danger-dim text-danger text-body">
                    {error}
                </div>
            </section>
        )
    }

    return (
        <section style={{ overflowX: 'auto' }}>
            <CustomTable
                data={dealsTableData}
                columns={dealsTableColumns}
                classlist={'strategies horizontal-border'}
                defaultSortColumn="Deal"
                sortByDesc={false}
            />
        </section>
    )
}
